import { useEffect, useState } from "react";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../firebase";
import { S, C } from "../ui";

// Only needed for the Staff Home "Check In" tab (Phase 11) — a QR scan
// already carries its one specific assetId (see FieldFlow.jsx), but a
// staff member logging in generally has no asset context yet, so they
// pick one themselves. Filtered to the worker's own trade by default
// (same matching FieldFlow.jsx does for the worker list), since that's
// almost always what they're there to document.
export default function AssetPicker({ facilityId, trade, onPick }) {
  const [assets, setAssets] = useState([]);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => onSnapshot(query(collection(db, "assets"), where("facilityId", "==", facilityId)), s =>
    setAssets(s.docs.map(d => ({ id: d.id, ...d.data() })))), [facilityId]);

  const visible = showAll ? assets : assets.filter(a => a.trade === trade);

  return (
    <div>
      <div style={{ fontSize: 13, color: C.muted, marginBottom: 10 }}>Which room or piece of equipment are you documenting?</div>
      {visible.length === 0 && (
        <div style={{ fontSize: 13, color: C.muted, marginBottom: 10 }}>
          No {showAll ? "" : trade + " "}assets set up yet{showAll ? "" : " — ask your admin, or"}
          {!showAll && <span onClick={() => setShowAll(true)} style={{ color: C.accent, cursor: "pointer" }}> browse every asset</span>}.
        </div>
      )}
      {visible.map(a => (
        <div key={a.id} onClick={() => onPick(a)}
          style={{ padding: "12px 14px", borderRadius: 10, border: `1.5px solid ${C.border}`, background: C.bg, marginBottom: 8, cursor: "pointer" }}>
          <div style={{ fontWeight: 600 }}>{a.name}</div>
          <div style={{ fontSize: 12, color: C.muted, textTransform: "capitalize" }}>{a.assetType} · {a.trade}</div>
        </div>
      ))}
      {!showAll && visible.length > 0 && assets.length > visible.length && (
        <div onClick={() => setShowAll(true)} style={{ fontSize: 12, color: C.accent, cursor: "pointer", marginTop: 4 }}>Show every asset, not just {trade} →</div>
      )}
    </div>
  );
}
